(function() {
	if ($('#berufsmessenForm').length) {

		$('#berufsmessenForm input[name="tx_datamintscareerfairs_search[location]"]').focus(function(){
			$('.berufsmessen-container #search-info').removeClass('d-none');
		});
		$('#berufsmessenForm button[type="submit"]').click(function() {
			$('.berufsmessen-container #search-info').addClass('d-none');
		})
	}
})();
